export function RecentActivity({ users, engagement }) {
  return (
    <div className="bg-gradient-to-r from-purple-500/10 to-pink-500/10 border border-white/10 rounded-xl p-6">
      <h3 className="text-lg font-semibold mb-4">Last 30 Days Activity</h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="text-center">
          <p className="text-4xl font-bold text-purple-400">{users.recent_signups}</p>
          <p className="text-gray-400">New Fan Signups</p>
        </div>
        <div className="text-center">
          <p className="text-4xl font-bold text-pink-400">{engagement.recent_purchases}</p>
          <p className="text-gray-400">New Purchases</p>
        </div>
        <div className="text-center">
          <p className="text-4xl font-bold text-cyan-400">{users.subscribers}</p>
          <p className="text-gray-400">Total Subscribers</p>
        </div>
      </div>
    </div>
  );
}
